// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/background-rect.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-wrapper {
  padding-bottom: 120px;
}
.products-container {
  margin: 8px 14px;
}

.products-item {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  margin-bottom: 10px;
  border-bottom: 1px solid #D8D8D8;
}

.first-column {
  width: 43%;
}

.edit-second-column {
  position: relative;
  width: 43%;
}

.edit-third-column {
  width: 14%;
}

.edit-first-column {
  width: 43%;
}

.second-column {
  position: relative;
  width: 35%;
}

.third-column {
  width: 22%;
}

.products-heading-item {
  text-transform: uppercase;
  color: #4A4A4A;
  font-size: 12px;
  line-height: 16px;
  border-bottom: 1px solid #EAEAEA;
  font-weight: bold;
  letter-spacing: 1px;
}

.product-name {
  font-size: 16px;
  line-height: 19px;
  color: #000;
}

.product-priceInfo {
  font-size: 12px;
  color: #4A4A4A;
  margin-top: 5px;
}

.product-quantity-input {
  background: #ECECEC;
  border-radius: 5px;
  border: 1px solid #979797;
  max-width: 94px;
  height: 38px;
  position: relative;
}

.product-quantity-input .customProductInput {
  height: 100%;
}

.product-quantity-input .customProductInput input {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  border-radius: 5px;
  background: transparent;
  padding: 14px 20px 14px 10px;
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
}
.product-quantity-input .btn-input-clear {
  position: absolute;
  right: 6px;
  top: 30%;
  cursor: pointer;
}

.product-quantity-input .btn-input-delete {
  position: absolute;
  right: -25px;
  top: 30%;
  cursor: pointer;
}

.btn-input-unit {
  position: absolute;
  right: 6px;
  top: 22%;
}

.product-quantity-input .btn-input-clear img {
  width: 15px;
}

.product-quantity-input .btn-input-delete img {
  width: 15px;
}

.customProductSelect select {
  width: 78px;
  height: 38px;
  border-radius: 5px;
}

.quantity-error {
  position: absolute;
  bottom: -18px;
  margin-top: 5px;
  font-size: 12px;
  color: #D0021B;
}

.bottom-section {
  /* position: absolute; */
  position: fixed;
  bottom: 0px;
  width: 100%;
  display: flex;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  padding: 17px 14px; 
  justify-content: space-between;
  align-items: center;
}

.bottom-section #btn-addSubmitOrder, .bottom-section #btn-confirmOrder {
  margin-top: 0px;
  font-weight: bold;
}


.total-items-txt {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
}

.total-approx-price {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
}

.products-list-caption, .heading-notice {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

.products-list-caption {
  margin: 13px 0 10px;
}

.products-edit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.products-list-heading .heading {
  font-weight: bolder;
  text-transform: uppercase;
  margin-top: 13px;
  margin-bottom: 5px;
}
.heading-notice {
  color: #DF3232;
  line-height: 17px;
  margin-bottom: 5px;
}

.products-bottom-wrapper {
  margin-bottom: 90px;
}

.card-container {
  width: 100%;
}

.card-container .product-img {
  width: 100%;
  height: auto;
}

.card-container .product-img img {
  width: 100%;
  height: 60vh;
}

.product-info {
  display: flex;
  justify-content: space-between;
}

.product-info .product-quantity .qty-handling {
  margin-left: 5px;;
}

.product-info .product-quantity .qty-handling input {
  text-align: center;
  border: none;
  outline: none;
  margin: 0px;
  width: 40px;
  height: 40px;
}

.product-info .product-quantity .qty-handling input[type=number]::-webkit-inner-spin-button,
.qty-handling input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.product-info .product-quantity .qty-handling .value-btn {
  border: none;
  border-radius: 5px;
  margin: 0px;
  width: 40px;
  height: 40px;
  text-align: center;
  vertical-align: middle;
  padding: 11px 0;
  background: #eee;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.product-info .product-quantity .qty-handling .value-btn:hover {
  cursor: pointer;
}

.red-badge {
  background-image: linear-gradient(to right, #970000,#e10202);
  color: #fff;
  display: inline-block;
  padding: 2px 8px;
  text-align: center;
  border-radius: 5px;
  font-size: 12px;
}

.green-badge {
  background-color: #007100;
  color: #fff;
  display: inline-block;
  padding: 2px 8px;
  text-align: center;
  border-radius: 5px;
  font-size: 12px;
}

.product-edit-container button {
  color: red;
  background: none;
  border: 0;
  outline: 0;
  cursor: pointer;
}

.no-record {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 100px;
}

.no-record img {
  width: 100px;
  height: 100px;
}

.no-record p {
  color: #e75752;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/ProductCatalog/productItem.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,WAAW;EACX,WAAW;EACX,aAAa;EACb,yDAAyD;EACzD,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EAIzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4DAA4D;EAC5D,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".products-wrapper {\n  padding-bottom: 120px;\n}\n.products-container {\n  margin: 8px 14px;\n}\n\n.products-item {\n  padding: 10px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 20px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #D8D8D8;\n}\n\n.first-column {\n  width: 43%;\n}\n\n.edit-second-column {\n  position: relative;\n  width: 43%;\n}\n\n.edit-third-column {\n  width: 14%;\n}\n\n.edit-first-column {\n  width: 43%;\n}\n\n.second-column {\n  position: relative;\n  width: 35%;\n}\n\n.third-column {\n  width: 22%;\n}\n\n.products-heading-item {\n  text-transform: uppercase;\n  color: #4A4A4A;\n  font-size: 12px;\n  line-height: 16px;\n  border-bottom: 1px solid #EAEAEA;\n  font-weight: bold;\n  letter-spacing: 1px;\n}\n\n.product-name {\n  font-size: 16px;\n  line-height: 19px;\n  color: #000;\n}\n\n.product-priceInfo {\n  font-size: 12px;\n  color: #4A4A4A;\n  margin-top: 5px;\n}\n\n.product-quantity-input {\n  background: #ECECEC;\n  border-radius: 5px;\n  border: 1px solid #979797;\n  max-width: 94px;\n  height: 38px;\n  position: relative;\n}\n\n.product-quantity-input .customProductInput {\n  height: 100%;\n}\n\n.product-quantity-input .customProductInput input {\n  width: 100%;\n  height: 100%;\n  border: none;\n  outline: none;\n  border-radius: 5px;\n  background: transparent;\n  padding: 14px 20px 14px 10px;\n  font-size: 16px;\n  line-height: 19px;\n  font-weight: bold;\n}\n.product-quantity-input .btn-input-clear {\n  position: absolute;\n  right: 6px;\n  top: 30%;\n  cursor: pointer;\n}\n\n.product-quantity-input .btn-input-delete {\n  position: absolute;\n  right: -25px;\n  top: 30%;\n  cursor: pointer;\n}\n\n.btn-input-unit {\n  position: absolute;\n  right: 6px;\n  top: 22%;\n}\n\n.product-quantity-input .btn-input-clear img {\n  width: 15px;\n}\n\n.product-quantity-input .btn-input-delete img {\n  width: 15px;\n}\n\n.customProductSelect select {\n  width: 78px;\n  height: 38px;\n  border-radius: 5px;\n}\n\n.quantity-error {\n  position: absolute;\n  bottom: -18px;\n  margin-top: 5px;\n  font-size: 12px;\n  color: #D0021B;\n}\n\n.bottom-section {\n  /* position: absolute; */\n  position: fixed;\n  bottom: 0px;\n  width: 100%;\n  display: flex;\n  background-image: url(\"../../assets/background-rect.png\");\n  background-size: cover;\n  padding: 17px 14px; \n  justify-content: space-between;\n  align-items: center;\n}\n\n.bottom-section #btn-addSubmitOrder, .bottom-section #btn-confirmOrder {\n  margin-top: 0px;\n  font-weight: bold;\n}\n\n\n.total-items-txt {\n  color: #fff;\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 24px;\n}\n\n.total-approx-price {\n  color: #fff;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n}\n\n.products-list-caption, .heading-notice {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n}\n\n.products-list-caption {\n  margin: 13px 0 10px;\n}\n\n.products-edit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.products-list-heading .heading {\n  font-weight: bolder;\n  text-transform: uppercase;\n  margin-top: 13px;\n  margin-bottom: 5px;\n}\n.heading-notice {\n  color: #DF3232;\n  line-height: 17px;\n  margin-bottom: 5px;\n}\n\n.products-bottom-wrapper {\n  margin-bottom: 90px;\n}\n\n.card-container {\n  width: 100%;\n}\n\n.card-container .product-img {\n  width: 100%;\n  height: auto;\n}\n\n.card-container .product-img img {\n  width: 100%;\n  height: 60vh;\n}\n\n.product-info {\n  display: flex;\n  justify-content: space-between;\n}\n\n.product-info .product-quantity .qty-handling {\n  margin-left: 5px;;\n}\n\n.product-info .product-quantity .qty-handling input {\n  text-align: center;\n  border: none;\n  outline: none;\n  margin: 0px;\n  width: 40px;\n  height: 40px;\n}\n\n.product-info .product-quantity .qty-handling input[type=number]::-webkit-inner-spin-button,\n.qty-handling input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.product-info .product-quantity .qty-handling .value-btn {\n  border: none;\n  border-radius: 5px;\n  margin: 0px;\n  width: 40px;\n  height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  padding: 11px 0;\n  background: #eee;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.product-info .product-quantity .qty-handling .value-btn:hover {\n  cursor: pointer;\n}\n\n.red-badge {\n  background-image: linear-gradient(to right, #970000,#e10202);\n  color: #fff;\n  display: inline-block;\n  padding: 2px 8px;\n  text-align: center;\n  border-radius: 5px;\n  font-size: 12px;\n}\n\n.green-badge {\n  background-color: #007100;\n  color: #fff;\n  display: inline-block;\n  padding: 2px 8px;\n  text-align: center;\n  border-radius: 5px;\n  font-size: 12px;\n}\n\n.product-edit-container button {\n  color: red;\n  background: none;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n}\n\n.no-record {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin-top: 100px;\n}\n\n.no-record img {\n  width: 100px;\n  height: 100px;\n}\n\n.no-record p {\n  color: #e75752;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
